import { Reducer } from 'redux';
import { PedidoEntregaState, PedidoEntregaTypes } from './types';

const INITIAL_STATE: PedidoEntregaState = {
  data: [],
  error: false,
  loadingPedidoEntrega: false,
};

const reducer: Reducer<PedidoEntregaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PedidoEntregaTypes.LOAD_REQUEST:
      return {
        ...state,
        loadingPedidoEntrega: true,
      };
    case PedidoEntregaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loadingPedidoEntrega: false,
        error: false,
        data: action.payload.data,
      };
    case PedidoEntregaTypes.LOAD_FAILURE:
      return {
        ...state,
        loadingPedidoEntrega: false,
        error: true,
        data: [],
      };
    case PedidoEntregaTypes.CLEAN_PEDIDO:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
